import React from "react";
import Loader from "react-loader-spinner";
import { useSelector } from "react-redux";
import { Roles } from "../../utils/Roles";
import "./Loading.scss";

/**
 * Global loader.
 * Student/parent: same blue arc spinner used in Messages.
 * Other roles: Oval spinner with primary color, matching previous ball-clip-rotate size.
 */
function Loading({ inline = false }) {
  const userRole = useSelector((state) => state.UserReducer?.userObj?.role);
  const isBlueLoader =
    userRole === Roles.STUDENT_NAME || userRole === Roles.PARENT_NAME;

  const className = [
    "loader-container",
    inline ? "loader-inline" : "",
    isBlueLoader ? "loader-blue" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={className}>
      <div className="loader-container-inner">
        <div className="text-center">
          {isBlueLoader ? (
            <div className="msg-style-loader" aria-label="Loading" />
          ) : (
            <Loader
              type="Oval"
              color="var(--primary-color)"
              height={70}
              width={70}
              ariaLabel="Loading"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Loading;
